@if ({ tagsStyles: tagsStyles$ | async }; as vm) {
  <div
    [ngClass]="{
      'wrap sidebar': tagLocation === 'sidebar',
      wrap: tagLocation === 'dashboard',
      dashboard: tagLocation === 'dashboard' && !isDropdownOpen,
      'dashboard-tags-open': tagLocation === 'dashboard' && isDropdownOpen,
    }"
    class="tags-cell"
    #tagsCell
    (click)="$event.stopPropagation()"
    [id]="tagsCellId"
  >
    @if (tags.size === 0 && tagLocation === 'sidebar') {
      <button
        pButton
        severity="secondary"
        size="small"
        class="m-2"
        (click)="op.toggle($event); $event.stopPropagation(); closeAllOtherPanels(op)"
        [disabled]="!isEditable()"
      >
        <i class="pi pi-plus-circle icon"></i><span class="ms-2">Add Tag</span>
      </button>
    }

    @if (tagLocation === 'dashboard' || (isEditable() && (tagLocation === 'grid' || tags.size > 0))) {
      <button
        class="add-tag-button grid-tag btn"
        [ngClass]="{ sidebar: tagLocation === 'sidebar' }"
        (click)="op.toggle($event); $event.stopPropagation(); closeAllOtherPanels(op)"
        pTooltip="Add a tag"
        tooltipPosition="top"
        #addTagBtn
      >
        <i class="pi pi-plus-circle icon"></i>
      </button>
    }

    @for (tag of tags; track tag.guid) {
      <button
        #tagItem
        [ngStyle]="{
          '--tag-text-color': tag?.guid | getTagStyle: 'textColor' : vm.tagsStyles,
          '--tag-background-color': tag?.guid | getTagStyle: 'backgroundColor' : vm.tagsStyles,
          '--tag-hover-text-color': tag?.guid | getTagStyle: 'hoverTextColor' : vm.tagsStyles,
          '--tag-hover-background-color': tag?.guid | getTagStyle: 'hoverBackgroundColor' : vm.tagsStyles,
        }"
        class="chip whiteSpaceNoWrap"
        (click)="removeTag(tag); $event.stopPropagation(); closeAllOtherPanels(op)"
      >
        <span class="chip-text">{{ tag?.name }}</span>
        @if (isEditable() && !isTagReadOnly(tag)) {
          <i class="pi pi-times remove-icon" pTooltip="Remove tag" tooltipPosition="top"></i>
        }
      </button>
    }

    <div
      class="tags-count"
      [ngClass]="{ 'd-none': tagLocation === 'grid' || hideTagCount() || hiddenTagsCount === 0, hideElement: hiddenTagsCount === 0 }"
      #tagsCount
    >
      +{{ hiddenTagsCount }}
    </div>

    <div
      [ngClass]="{ 'd-none': tagLocation !== 'dashboard', hideElement: hiddenTagsCount === 0 || isDropdownOpen }"
      class="loan-actions"
      #boltMenuHandler
      (click)="toggleDropdown($event)"
    >
      <div class="bolt-button d-flex align-items-center py-3">
        <i class="pi pi-angle-down"></i>
      </div>
    </div>

    <!-- add a tag panel -->
    <p-popover
      #op
      appendTo="body"
      [styleClass]="tagLocation === 'sidebar' ? 'tags-op sidebar' : 'tags-op'"
      [style]="{ height: '245px', width: '180px' }"
      (onHide)="isDropdownOpen = false"
    >
      <p-scrollPanel [style]="{ height: '218px', width: '162px' }" styleClass="brand-scrollbar">
        <div class="dropdown">
          <div>Select a tag</div>
          @for (tag of filteredUnselectedTags$ | async; track tag.guid) {
            <button
              [ngStyle]="{
                '--tag-text-color': tag?.guid | getTagStyle: 'textColor' : vm.tagsStyles,
                '--tag-background-color': tag?.guid | getTagStyle: 'backgroundColor' : vm.tagsStyles,
                '--tag-hover-text-color': tag?.guid | getTagStyle: 'hoverTextColor' : vm.tagsStyles,
                '--tag-hover-background-color': tag?.guid | getTagStyle: 'hoverBackgroundColor' : vm.tagsStyles,
              }"
              class="btn chip"
              (click)="addTag(tag); op.hide()"
            >
              <span class="chip-text">{{ tag?.name }}</span>
            </button>
          }
        </div>
      </p-scrollPanel>
    </p-popover>

    <!-- show added tags panel -->
    <p-popover
      #selectedTagsPanel
      appendTo="body"
      [styleClass]="tagLocation === 'sidebar' ? 'tags-op sidebar' : 'tags-op selected-tags'"
      [style]="{ height: 'h-auto', width: '600' }"
      (onHide)="isDropdownOpen = false"
    >
      <p-scrollPanel [style]="{ height: '218px', width: '162px' }" styleClass="brand-scrollbar">
        <div class="selected-tags-container">
          @for (tag of selectedTags$.value; track tag.guid) {
            <button
              style="margin-bottom: 0.8rem"
              [ngStyle]="{
                '--tag-text-color': tag?.guid | getTagStyle: 'textColor' : vm.tagsStyles,
                '--tag-background-color': tag?.guid | getTagStyle: 'backgroundColor' : vm.tagsStyles,
                '--tag-hover-text-color': tag?.guid | getTagStyle: 'hoverTextColor' : vm.tagsStyles,
                '--tag-hover-background-color': tag?.guid | getTagStyle: 'hoverBackgroundColor' : vm.tagsStyles,
              }"
              class="btn chip"
            >
              <span class="chip-text">{{ tag?.name }}</span>
              <i class="pi pi-times remove-icon" (click)="removeTag(tag); $event.stopPropagation()" pTooltip="Remove tag" tooltipPosition="top"> </i>
            </button>
          }
        </div>
      </p-scrollPanel>
    </p-popover>
  </div>
}

<!-- open close tags dashboard-->
@if (tagLocation === 'dashboard' && tags.size > 0 && isDropdownOpen) {
  <div class="loan-actions--open" #boltMenuHandler (click)="toggleDropdown($event)">
    <div class="bolt-button d-flex align-items-center py-3">
      <i class="pi pi-angle-up"></i>
    </div>
  </div>
}
